import React from 'react'
import './traingle.css'

const TraingleLoading = () => {
  return (
     <div className="spinner-loading-box">
    
    <div class="traingle-loader"></div>
    </div>
    
  )
}

export default TraingleLoading